









































import Vue from 'vue'
import Seguranca from '@/Apis/Seguranca/Seguranca'

export default Vue.extend({
  name: 'TokenExchangeView',
  data() {
    return {
      status: 'idle' as 'idle' | 'loading' | 'success' | 'error',
      message: '',
      cpfNotFound: false,
    }
  },
  async mounted() {
    const uuid = (this.$route.query.uuid || this.$route.params.uuid) as string
    const identificador = (this.$route.query.identificador || this.$route.params.identificador) as string | undefined

    if (!uuid) {
      this.status = 'error'
      this.message = 'UUID não informado.'
      return
    }

    this.status = 'loading'
    this.message = 'Carregando informações de login...'

    try {
      await this.clearPreviousSession()
      const token = await (Seguranca as any).TokenExchangePublic.exchange(uuid, identificador)
      await (Seguranca as any).TokenExchangePublic.setAppUserFromExchange(token)
      this.status = 'success'
      this.message = 'Login realizado com sucesso.'

      setTimeout(() => {
        try {
          const destination = this.resolveDestination()
          window.location.replace(destination)
        } catch (e) {
          const fallback = this.resolveDestination()
          ;(this as any).$router.push(fallback).catch(() => {})
        }
      }, 1000)
    } catch (err) {
      const anyErr = err as any
      this.status = 'error'
      this.message = (anyErr && anyErr.message) || JSON.stringify(anyErr)
      this.cpfNotFound = this.isCpfNotFoundError(this.message)
    }
  },
  methods: {
    isCpfNotFoundError(message: string): boolean {
      if (!message) return false
      return message.includes('CPF_NOT_FOUND') ||
        message.includes('Nenhum usuário correspondente ao CPF informado foi localizado')
    },

    resolveDestination(): string {
      try {
        const knownKeys = ['profile']

        for (const key of knownKeys) {
          const raw = localStorage.getItem(key)
          if (!raw) continue

          const parsed = JSON.parse(raw)

          const defaultPageView =
            (parsed && parsed.profile && parsed.profile.defaultPage && parsed.profile.defaultPage.view) ||
            (parsed && parsed.defaultPage && parsed.defaultPage.view)

          if (defaultPageView) {
            return `/${defaultPageView}`
          }
        }
      } catch {
        // JSON inválido ou chave inexistente — segue para fallback
      }

      // Fallback: última rota visitada ou /recebimento
      return localStorage.getItem('lastPath') || '/recebimento'
    },

    goHome() {
      ;(this as any).$router.push('/inicio')
    },

    async clearPreviousSession() {
      localStorage.clear()
    },
  },
})
